module.exports = __webpack_public_path__ + "static/after-2-5117c2228b12258c34d92e3eabafca62.png";